export const ORDER_LINE_DATE_FORMAT = 'MMM d, yyyy';
export const ORDER_LINE_NUMBER_FORMAT = '1.2-2';
export const emptyOrderDetailFilterValue = 'empty';
export const ORDER_COLUMN_QUANTITY_FORMAT = '1.0-0';
export const EXPORT_XLS_FILE_DEFAULT_NAME = 'order-history.xls';
export const ORDER_BOOK_SEARCH_URL_PARAM = 'ob_search';
export const ASSOCIATED_ACCOUNT_FILTER_ID = 'associatedAccount';
